import React from "react";
import Footer from "@/components/Footer";
import styles from "./index.scss";
// const crypto = require('crypto');

// 业务容器组件
function WithComponent(config: any) {
    return (ShowCompinent: React.FC) => {
        function WithContainer(props) {
            return (
                <div className={styles.loginContent}>
                    <ShowCompinent {...props} />
                    <Footer />
                </div>
            );
        }
        return WithContainer;
    };
}

export default WithComponent;